import React from 'react';
import { sanitizePayload } from '../../../utils/textSanitizer';
import './RichTextEditor.css';

/**
 * Safely renders formatted HTML strings across cards, detail modals, and public pages.
 */
export default function RichTextRenderer({ content = '', className = '', style = {} }) {
  if (!content) return null;

  // Convert markdown fallback to clean HTML if needed
  let html = content;
  if (typeof html === 'string' && !/<[a-z][\s\S]*>/i.test(html)) {
    html = html
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      .replace(/\*(.*?)\*/g, '<em>$1</em>')
      .replace(/<u>(.*?)<\/u>/g, '<u>$1</u>')
      .replace(/`(.*?)`/g, '<code>$1</code>')
      .replace(/^\s*[•\-*]\s+(.*)$/gm, '<li>$1</li>')
      .replace(/(<li>[\s\S]*?<\/li>)/s, '<ul>$1</ul>')
      .replace(/\n\n/g, '<p></p>')
      .replace(/\n/g, '<br />');
  }

  // Sanitize XSS payloads
  const sanitizedHtml = sanitizePayload(html);

  return (
    <div
      className={`rte-rendered ${className}`}
      style={{ minHeight: 'auto', ...style }}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
}
